export const prepareUserData = (userDto) => {
  if (userDto) {
    const {family_name, given_name} = userDto;
    return {firstName: given_name, lastName: family_name};
  }

  return null;
};
